const initialState = {
    favList: [], // faghat slug ha zakhire mishe
    products: [],
};

const favoriteList = (state = initialState, action) => {

    switch (action.type) {

        case 'CHANGE_DATA_PAGE_FAVORITE':
            return {...state, [action.name]: action.value};

        case 'ACTION_ADD_TO_FAVORITE_LIST':
            const stateFavorites = [...state.favList]; // fav items before added or updated new row

            const newItem = action.slug;
            const exists = state.favList.some(item => item === newItem);
            if (!exists) 
                stateFavorites.push(newItem);

            return {...state, favList:  stateFavorites};

        case 'ACTION_REMOVE_FROM_FAVORITE_LIST':
            return {
                ...state,
                favList: state.favList.filter(item => item !== action.slug)
            };

        case 'ACTION_REMOVE_ALL_ITEM_IN_FAVORITE_LIST':
            return {...state, favList: []};

        default:
            return state;
    }
};

export default favoriteList;
